import React from "react";
import { NavLink } from "react-router-dom";
import "./Footer.css";
import Logo from "../../Pictuers/UniTech_PNG.png";
import {
  UilMapMarker,
  UilPhone,
  UilEnvelope,
  UilLinkedin,
  UilFacebook,
  UilYoutube
} from "@iconscout/react-unicons";
import { useTranslation } from "react-i18next";

/* Menu Solutions masqué pour le moment : lien Produits conservé pour réactivation. */
const SHOW_SOLUTIONS_MENU = false;

/* Même ordre que le Menu principal validé ; libellés i18n conservés. */
const PAGES = [
  { to: "/", key: "home" },
  { to: "/openlift", key: "openlift" },
  ...(SHOW_SOLUTIONS_MENU ? [{ to: "/produits", key: "products" }] : []),
  { to: "/nous-sommes", key: "about" },
  { to: "/blog", key: "blog" },
  { to: "/contact", key: "contact" },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-grid">
          {/* --- Col 1: Brand --- */}
          <div className="footer-brand">
            <a
              href="/"
              className="brand"
              aria-label={t("footer.brand_aria_home")}
            >
              <span className="brand-sq">
                <img src={Logo} alt="UniTech" />
              </span>
            </a>
            <p className="brand-tagline">
              {t("footer.brand_tagline")}
            </p>
          </div>

          {/* --- Col 2: Pages --- */}
          <nav className="footer-nav" aria-label={t("footer.nav_aria")}>
            <h3 className="footer-heading">{t("footer.pages_heading")}</h3>
            <ul className="footer-links">
              {PAGES.map((p) => (
                <li key={p.to}>
                  <NavLink to={p.to} className="footer-link">
                    {t(`footer.pages.${p.key}`)}
                  </NavLink>
                </li>
              ))}
            </ul>
          </nav>

          {/* --- Col 3: Contact --- */}
          <div className="footer-contact">
            <h3 className="footer-heading">{t("footer.contact_heading")}</h3>
            <ul className="contact-list">
              <li>
                <span className="contact-ico" aria-hidden="true">
                  <UilMapMarker size="18" />
                </span>
                <span>{t("footer.address")}</span>
              </li>
              <li>
                <span className="contact-ico" aria-hidden="true">
                  <UilPhone size="18" />
                </span>
                <a
                  className="contact-link"
                  href={`tel:${t("footer.phone_href")}`}
                >
                  {t("footer.phone_display")}
                </a>
              </li>
              <li>
                <span className="contact-ico" aria-hidden="true">
                  <UilEnvelope size="18" />
                </span>
                <a
                  className="contact-link"
                  href={`mailto:${t("footer.email")}`}
                >
                  {t("footer.email")}
                </a>
              </li>
            </ul>

            <div className="socials" aria-label={t("footer.socials_aria")}>
              <a
                className="social-btn"
                href="https://www.linkedin.com/company/unitechengineering/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.linkedin")}
              >
                <UilLinkedin size="18" />
              </a>
              <a
                className="social-btn"
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.facebook")}
              >
                <UilFacebook size="18" />
              </a>
              <a
                className="social-btn"
                href=""
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t("footer.socials.youtube")}
              >
                <UilYoutube size="18" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>{t("footer.copyright", { year })}</p>
        </div>
      </div>
    </footer>
  );
}
